module.exports = __webpack_public_path__ + "img/facettedconnections.219f717.webp";